var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85742 3.35917C2.85742 2.72798 3.3691 2.21631 4.00028 2.21631H16.0003C16.6315 2.21631 17.1431 2.72798 17.1431 3.35917V13.9227C17.1431 14.661 16.8573 15.3707 16.3455 15.903L14.4148 17.9109C13.8761 18.4711 13.1325 18.7877 12.3553 18.7877H4.00028C3.3691 18.7877 2.85742 18.2761 2.85742 17.6449V3.35917Z",
    fill: "#B9D6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.7876L14.2857 14.7876C13.6545 14.7876 13.1429 15.2993 13.1429 15.9305L13.1429 17.6448",
    stroke: "#8CBBC8",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.14258,
    y: 5.07349,
    width: 9.71429,
    height: 1.14286,
    rx: 0.571429,
    fill: "#8CBBC8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14258,
    y: 7.93042,
    width: 9.71429,
    height: 1.14286,
    rx: 0.571429,
    fill: "#8CBBC8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14258,
    y: 10.7876,
    width: 8,
    height: 1.14286,
    rx: 0.571429,
    fill: "#8CBBC8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14258,
    y: 13.6448,
    width: 4,
    height: 1.14286,
    rx: 0.571429,
    fill: "#8CBBC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.469 3.86964C17.6921 3.64648 18.054 3.64648 18.2771 3.86964L19.4893 5.08182C19.7124 5.30498 19.7124 5.66679 19.4893 5.88994L11.8929 13.4863C11.5729 13.8064 11.1926 14.0599 10.774 14.2322L9.24168 14.8632C8.772 15.0566 8.30233 14.5869 8.49572 14.1172L9.12668 12.5849C9.29903 12.1664 9.55256 11.7861 9.87264 11.466L17.469 3.86964Z",
    fill: "#62A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool9);
export default __webpack_public_path__ + "static/media/tool_9.de437f76d17c0b1451b2c351e24b03bf.svg";
export { ForwardRef as ReactComponent };